import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import Http from '../../../Http';
import { objectAsParams } from '../../../helpers';

class BuscarEvidencias extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: '', saveUrl: '', backUrl: '' },
      new Form([
        Form.Field('date', 'start_date', 'Fecha Entrega Inicial', '', [], 4),
        Form.Field('date', 'end_date', 'Fecha Entrega Final', '', [], 4),
        Form.Field('autocomplete', 'id_cliente', 'Cliente', '', [], 4),
        Form.Field('autocomplete', 'id_chofer', 'Chofer', '', [], 4),
        Form.Field('number', 'start_score', 'Calificacion Minima', '', [], 4),
        Form.Field('number', 'end_score', 'Calificacion Maxima', '', [], 4),
        Form.Field('text', 'folio_guia', 'Folio Guia', '', [], 4),
      ], ['Buscar'], 'Revision de Evidencias'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  formData = async (form) => {
    const params = {};
    let newForm = form;
    if (this.clienteSearch) {
      params.cliente = this.clienteSearch;
      this.clienteSearch = null;
    }
    if (this.choferSearch) {
      params.chofer = this.choferSearch;
      this.choferSearch = null;
    }

    const Res = await Http.get(`revision-evidencia/form?${objectAsParams(params)}`);

    if (!Res.error) {
      const { clientes, choferes } = Res.data;

      if (clientes) {
        newForm = Form.FieldOptions(newForm, 'id_cliente', clientes, 'id', 'cliente');
      }
      if (choferes) {
        newForm = Form.FieldOptions(newForm, 'id_chofer', choferes, 'id', 'chofer');
      }
    }

    newForm = Form.ValueChange(newForm, {
      id_cliente: (field) => {((field.ValueAt && field.ValueAt.length > 2) || (field.Value && field.Value.length > 0)) && (this.clienteChange(field)) },
      id_chofer: (field) => {((field.ValueAt && field.ValueAt.length > 2) || (field.Value && field.Value.length > 0)) && (this.choferChange(field)) },
    });
    return newForm;
  }

  clienteChange = async (field) => {
    if (!(field.Value && !isNaN(field.Value))) {
      this.clienteSearch = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData)
      });
    }
  }

  choferChange = async (field) => {
    if (!(field.Value && !isNaN(field.Value))) {
      this.choferSearch = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData)
      });
    }
  }


  onSubmit = (i, vals) => {
    this.props.onSave(vals)
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(BuscarEvidencias)
